import React, { ComponentType, useRef } from 'react';

import L from 'leaflet';
import { Marker as LeafletMarker, Popup as LeafletPopup } from 'react-leaflet';

const Marker = LeafletMarker as unknown as ComponentType<{
  position: [number, number];
  icon?: L.DivIcon;
  ref?: React.Ref<L.Marker>;
  children?: React.ReactNode;
}>;

const Popup = LeafletPopup as unknown as ComponentType<{
  children?: React.ReactNode;
  closeButton?: boolean;
  autoClose?: boolean;
  closeOnClick?: boolean;
  offset?: [number, number];
}>;

type TMapMarkerWithPopupProps = {
  position: [number, number];
  icon: L.DivIcon;
  children: (closePopup: () => void) => React.ReactNode;
};

export const MapMarkerWithPopup = ({ position, icon, children }: TMapMarkerWithPopupProps) => {
  const markerRef = useRef<L.Marker | null>(null);

  const closePopup = () => {
    markerRef.current?.closePopup();
  };

  return (
    <Marker ref={markerRef} position={position} icon={icon}>
      <Popup closeButton autoClose closeOnClick>
        {children(closePopup)}
      </Popup>
    </Marker>
  );
};
